import { AnyEventObject } from 'xstate';
import { Context } from './types';

export const setLoading = (): Partial<Context> => ({ loading: true });
export const resetLoading = (): Partial<Context> => ({ loading: false });

// [MCV-1543] See Context.pendingDraft — the exit flush hands over the only
// surviving copy of the user's edits, so it is held here until the write for it
// succeeds rather than living in the form that is already unmounting.
export const retainDraft = ({ event }: { event: AnyEventObject }): Partial<Context> => ({
  pendingDraft: event.payload?.values,
});

// [MCV-1543] The invariant is "pendingDraft holds step values that are not yet
// written", so EVERY successful write releases it — not just the ON_SAVE that
// stored it. A recovered draft makes the form re-send on the next Next, and
// that ON_UPDATE supersedes the draft wholesale (it PATCHes the same detail
// with the whole form). Leaving the draft behind meant a later remount
// preferred it over the newer persisted values and re-saved the stale ones.
export const clearDraft = (): Partial<Context> => ({ pendingDraft: undefined });
